/**
 * Restricts routes to organization account admins (CUSTOMER_ADMIN) and platform admins.
 */

import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map, take } from 'rxjs/operators';
import { AuthService } from '../../services/auth.service';
import { RoutePaths } from '../constants';
import { canManageTeam } from '../utils/user-role.utils';

export const customerAdminGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return authService.getProfile().pipe(
    take(1),
    map((user) => {
      if (canManageTeam(user)) {
        return true;
      }
      return router.createUrlTree([RoutePaths.DASHBOARD]);
    })
  );
};
